import styled from 'styled-components'

import Form from '~/components/form'

export const StyledIframe = styled.iframe<{
  $frameHeight: number
}>`
  width: 100%;
  height: ${(props) => `${props.$frameHeight}px`};
  border: none;
`

export const StyledForm = styled(Form)`
  .amp-base && {
    .amp-form-field {
      margin: 0 0 5px 0;

      .amp-text-input-label {
        font-family: 'futura', sans-serif;
        font-weight: 400;
        font-size: 14px;
      }
    }

    .amp-form-field .amp-error-message p {
      font-size: 90%;
    }
  }
`
